module.exports = __webpack_public_path__ + "static/media/fondsPourLeJournalism.c89fe4fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fondsPourLeJournalism.png
// module id = 1615
// module chunks = 0